import {Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild} from '@angular/core';
import { SolicitacaoHonra } from 'src/app/model/solicitacao-honra.model';
import { ProtocoloArquivo } from 'src/app/model/protocolo-arquivo.model';
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { SolicitacaoHonraService } from '../solicitacao-honra/solicitacao-honra.service';
import { EntityOrderedRequestParameters, EntityPagedResult, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import Utils from 'src/app/shared/fgi-utils';
import { NgForm } from '@angular/forms';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';

@Component({
    selector: 'app-solicitacao-honra-prioridade',
    templateUrl: './solicitacao-honra-prioridade.component.html',
    styleUrls: ['./solicitacao-honra-prioridade.component.scss'],
    standalone: false
})
export class SolicitacaoHonraPrioridadeComponent implements OnInit, OnChanges  {
    
    @Input() protocoloSHs: ProtocoloArquivo;
    @Input() acaoPriorizacao: String;  
    @Input() ocorrenciasCadastroSH: OcorrenciaValidacaoVO[]
    @Output() aoConfirmarRepriorizacao: EventEmitter<SolicitacaoHonra[]> = new EventEmitter<SolicitacaoHonra[]>();
  
    private atributosPaginacao: EntityPagedResult<SolicitacaoHonra>;
    private atributosOrdenacao: EntityOrderedRequestParameters;
    private opcoesPaginacao: number[];
    @ViewChild('formPriorizacao', {static: false}) form: NgForm;
    private prioridadeSHs: SolicitacaoHonra[];
    private cnpjUsuario: string;
    public ocorrencias: OcorrenciaValidacaoVO[] = [];

    constructor(
        private usuarioService: BnUsuarioService,
        //private messageService: MessageChannelService,
        private service: SolicitacaoHonraService,) {

        this.opcoesPaginacao = [5, 10];
        this.atributosPaginacao = {
            page: 1,
            pageSize: this.opcoesPaginacao[0],
            pages: undefined,
            count: undefined,
            list: undefined
        };            
        this.atributosOrdenacao = {
            atributo: '',
            sentido: 'asc'
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        //console.debug(changes);
        console.debug(`acaoPriorizacao: ${this.acaoPriorizacao}`);
        if (changes.acaoPriorizacao && this.acaoPriorizacao?.startsWith('confirmar')) {
            //console.debug(`prioridadeSHs: ${JSON.stringify(this.prioridadeSHs)}`);
            this.ocorrencias.length=0;
            if (this.prioridadeSHs.find(sh => sh.prioridadeNova != sh.prioridadeOriginal) == undefined) {
                const oc = new OcorrenciaValidacaoVO('Nenhuma prioridade foi modificada.', 'A');
                this.ocorrencias.push(oc);
                return;
            }
            
            this.prioridadeSHs = this.prioridadeSHs.sort((a,b) => Utils.compara(a, b, "prioridadeNova"));
            for (let i = 0; i < this.prioridadeSHs.length-1; i++) {
                const shCorrente = this.prioridadeSHs[i];
                const shSeguinte = this.prioridadeSHs[i+1];
                if (shCorrente.prioridadeNova == shSeguinte.prioridadeNova) {
                    const oc = new OcorrenciaValidacaoVO(`As solicitações 
                          "${!shCorrente.contratoRepasse ? shCorrente.idOperacaoExterno : shCorrente.sistemaRepasse + '/' + shCorrente.contratoRepasse}" 
                        e "${!shSeguinte.contratoRepasse ? shSeguinte.idOperacaoExterno : shSeguinte.sistemaRepasse + '/' + shSeguinte.contratoRepasse}" 
                        estão com a mesma prioridade.`, 'A');
                    this.ocorrencias.push(oc);
                }
            }
            if (this.ocorrencias.length) {
                return;
            }

            this.aoConfirmarRepriorizacao.emit(this.prioridadeSHs);
        };
    }

    ngOnInit() {
        this.usuarioService.usuario$.subscribe(usuario => {
            this.cnpjUsuario = usuario.cnpj;
        });
        
        const params: any = {
            cnpjAgenteFinanceiro: this.cnpjUsuario
            //sem limite !
            //pagina: 1;
            //limite: 2000; 
        };        
        this.service.getSolicitacoesHonraPorProtocoloNegocio(this.protocoloSHs?.idProtocoloNegocio, params).subscribe(
            response => {
                let inc: number = 0;
                this.prioridadeSHs = response.resultados.map((i: SolicitacaoHonra) => {
                    i.prioridadeOriginal = (inc+=1);
                    i.prioridadeNova = i.prioridadeOriginal;
                    return i
                });

                this.atributosPaginacao.count = response.totalRegistrosSemPaginacao;
                this.mudancaPagina(this.atributosPaginacao);
        });
        this.addClasseFormLabel();
    }

    mudancaPagina(novaPagina: EntityPagedResult<SolicitacaoHonra>) {    
        this.atributosPaginacao.page = novaPagina.page;
        this.atributosPaginacao.pageSize = novaPagina.pageSize;
        const start = (this.atributosPaginacao.page-1) * this.atributosPaginacao.pageSize;
        const end = this.atributosPaginacao.page * this.atributosPaginacao.pageSize;
        this.atributosPaginacao.list = this.prioridadeSHs.slice(start, end);
        // console.log(this.atributosPaginacao);
    }

    mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
        this.atributosOrdenacao = novaOrdenacao;
        this.atributosPaginacao.list = this.atributosPaginacao.list.sort((a, b) => {
            if (novaOrdenacao.sentido == "asc") {
              return Utils.compara(a, b,novaOrdenacao.atributo);
            }
            else {
              return -1 * Utils.compara(a, b, novaOrdenacao.atributo);
            }
        });
    }

    aumentar (posicao: number) {
        if (posicao == 0 ) return;
        //console.log(posicao);
        this.permutaItens(posicao-1, posicao);
    }

    reduzir (posicao: number) {
        if (posicao == this.atributosPaginacao.list.length-1 ) return;
        this.permutaItens(posicao+1, posicao);
    }

    permutaItens( posA: number, posB: number) {
        [this.atributosPaginacao.list[posA], this.atributosPaginacao.list[posB]] = 
            [this.atributosPaginacao.list[posB], this.atributosPaginacao.list[posA]];
        const pA = this.atributosPaginacao.list[posA].prioridadeNova;
        this.atributosPaginacao.list[posA].prioridadeNova = this.atributosPaginacao.list[posB].prioridadeNova;
        this.atributosPaginacao.list[posB].prioridadeNova = pA;
    }

    addClasseFormLabel() {
        setTimeout(() => {
            const bnPaginacao = document.getElementById('bnPaginacao');
            const labels = bnPaginacao?.getElementsByTagName('label');
            for (let i =0; i < labels?.length; i++) {
                labels[i].classList.add('form-label');
            }
        }, 0)
    }
}

